import { GetSystemListParameters, getSystemLists } from "@iewc/Services/CommonService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

interface Parameter {
    namelist: string;
}

interface Props {
    getSystemListsParameters: GetSystemListParameters;
}

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.getSystemListsParameters = {
        namelist: props.parameter.namelist,
    };
};

export const FetchSystemList: HandlerType = props => {
    getSystemLists(props.getSystemListsParameters).then(data => {
        if (data.successful) {
            for (const key in data.result) {
                let newKey = key;
                switch (key) {
                    case "ReturnRequestOrderResponse":
                        newKey = "return-request";
                        break;
                    case "ChangeOrderResponse":
                        newKey = "change-order";
                        break;
                    case "EditQuoteResponse":
                        newKey = "edit-quote";
                        break;
                    case "CancelQuoteResponse":
                        newKey = "cancel-quote";
                        break;
                }
                props.dispatch({
                    type: "Custom/SystemList/SetSystemListByKey",
                    key: newKey,
                    value: data.result[key],
                } as any);
            }
        }
    });
};

export const chain = [PopulateApiParameter, FetchSystemList];

const loadSystemLists = createHandlerChainRunner(chain, "LoadSystemLists");
export default loadSystemLists;
